import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import TransitsPage from '@/pages/transits/transit-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'transits',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <TransitsPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: {
    titleKey: 'Transits',
  },
});
